/// <reference path='../_all.ts' />

module tabs {
  'use strict';

  /**
   *
   */
  tabPage.$inject = [
    '$timeout', 
    '$window', 
    'anchorNavService', 
    'pageMetaService', 
    'parallaxService', 
    'debounce',
  ];
  export function tabPage(
    $timeout :ng.ITimeoutService
    , $window : ng.IWindowService
    , anchorNavService : navigation.IAnchorNavService
    , pageMetaService: navigation.IPageMetaService
    , parallaxService : navigation.IParallaxService
    , debounce:  navigation.IDebounceService): ng.IDirective {
    
    return {
      transclude: true,
      restrict: 'A',
      scope: {
        pageId: '@',
        routeId: '@',
      },
      require: '^tabs',      
      link: function (scope : ITabPageScope, element : ng.IAugmentedJQuery, attr, controller : TabCtrl, transclude : ng.ITranscludeFunction) {
        transclude(scope, function(clone) {
         element.append(clone);
        });
        
        scope.t = controller.registerPage(element, scope.pageId, scope.routeId);        
        
        //function if tab is activated.
        scope.t.page.setActiveFunction = (active : boolean) => {

          scope.active = active;

          if (active) { //on activate set min-height to animate height, but only if we have a height.
            var setMinHeight = () => {
              var elHeight = $(element).children().outerHeight(true);
              if (!elHeight) {
                $timeout(setMinHeight, 100);
                return;
              }
              var section = $(element).closest("section");
              var padding = section.outerHeight(false) - section.height();
              section.css("min-height", padding + elHeight);
              //console.log("A:" + padding + ":" + elHeight);
            };
            setMinHeight();
          }
        };
      }
    }
  }
}